declare global {
  interface Window {
    VWO: {
      event: (...args: any[]) => void;
    };
  }
}

export const VWOAnalyticsService = {
  dispatchVWOEvent: (eventName: string) => {
    window.VWO = window.VWO || [];
    window.VWO.event =
      window.VWO.event ||
      ((...args) => {
        (window.VWO as unknown as any[]).push(['event'].concat([].slice.call(args)));
      });
    window.VWO.event(eventName);
  },
};
